import { isApiError } from '../api';

/**
 * What a refused Admin request means, in words (APP-044). The server's own detail wins when it
 * has one, since it names the person or field; these cover the codes whose title is generic.
 */
export function problemText(error: unknown): string {
  if (!isApiError(error))
    return 'That didn’t go through. Nothing was changed; try again in a moment.';
  switch (error.code) {
    case 'network_error':
      return 'We couldn’t reach MyRewards. Nothing was changed; try again in a moment.';
    case 'preview_read_only':
      return 'Preview is read-only. Exit preview to change it.';
    case 'preview_sample_data':
      return 'Preview shows sample data. Exit preview to see live records.';
    case 'conflict':
      return 'Someone changed this while you were working. Reload to see the latest.';
    case 'forbidden':
      return 'Your roles don’t let you change this.';
    default:
      return error.problem?.detail ?? error.problem?.title ?? error.message;
  }
}

/** A version or plan that moved on since the person read it: reload rather than retry. */
export function isStale(error: unknown): boolean {
  return (
    isApiError(error) &&
    error.status === 409 &&
    [
      'conflict',
      'import_changed',
      'import_version',
      'draft_changed',
      'setup_changed',
      'setup_version',
    ].includes(error.code)
  );
}
